import type { ReactNode } from 'react'
import { cn } from '@dogdisk/shared'
import { BackButton } from './back-button'

/**
 * Mobile PWA shell — caps width to ~402px (the design viewport),
 * full dvh, vertical scroll, white bg.
 */
export function MobileScreen({
  children,
  className,
  bg = 'white',
  noScroll,
}: {
  children: ReactNode
  className?: string
  bg?: 'white' | 'surface'
  noScroll?: boolean
}) {
  return (
    <div
      className={cn(
        'mx-auto flex w-full min-h-dvh max-w-[402px] flex-col',
        bg === 'surface' ? 'bg-[#F6F7F8]' : 'bg-white',
        noScroll ? 'overflow-hidden' : '',
        className,
      )}
    >
      {children}
    </div>
  )
}

/** Standard top bar with back arrow + centered title + optional right slot. */
export function TopBar({
  title,
  onBack,
  fallback,
  right,
  border,
  centered = true,
  hideBack,
}: {
  title?: ReactNode
  onBack?: () => void
  fallback?: string
  right?: ReactNode
  border?: boolean
  centered?: boolean
  hideBack?: boolean
}) {
  return (
    <header
      className={cn(
        'flex items-center justify-between gap-3 px-6 pt-[max(10px,env(safe-area-inset-top))] pb-3',
        border ? 'border-b border-[#F3F4F6]' : '',
      )}
    >
      <div className="flex w-11 items-center">
        {!hideBack && <BackButton onClick={onBack} fallback={fallback} />}
      </div>
      {title !== undefined && (
        <h1
          className={cn(
            'flex-1 truncate text-[17px] font-semibold text-[#1A1A1A]',
            centered ? 'text-center' : 'text-left',
          )}
        >
          {title}
        </h1>
      )}
      <div className="flex w-11 items-center justify-end">{right}</div>
    </header>
  )
}
